import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Material UI components
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

// Custom Components
import Filter from "@Components/Filter";
import Table from "components/Table";
import Modal from "@Components/Modal";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";


import { WORKER_CONTRACT_URL } from "configs/constants";
// import eightAxios from "configs/axiosConfig";
// import axios from "axios";

let model = [
  { id: "language", label: "Document Language", type: "string" },
  { id: "parsed_nationality", label: "Nationality", type: "string" },
  {
    id: "is_default",
    label: "Default",
    type: "boolean",
    yesValue: "Yes",
    noValue: "No",
  },
  { id: "status", label: "Status", type: "string" },
];
const isLanguageDelete = true;
const pageNumberDropdown = true;


// const FileDownload = require("js-file-download");
// const today = new Date();

const SendSms = (props) => {
  const { messageBody, setMessageBody } = props;
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <div>{messageBody}</div>
      </Grid>
      <Grid item>
        <TextField
          onChange={(event) => {
            setMessageBody(event.target.value);
          }}
          variant="outlined"
          row={5}
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
SendSms.propTypes = {
  messageBody: PropTypes.string,
  setMessageBody: PropTypes.func,
};

export default function UserList() {
  // Use a state to store the table's selected values and also provide a callback function
  const [messageBody, setMessageBody] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const history = useHistory();

  const [modalFields, setModalFields] = useState({
    title: "Send SMS",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Send",
    onConfirm: null,
    resetModalBodyState: setMessageBody,
  });
  // const setNotify = useNotifyContext();
 

  // actions mode for data table.
  const actions = [ 
    
    "edit"
  ]
    ;

  const filterFields = [
    {
      type: "reactselect",
      label: "Document Language",
      name: "language",
      outerOptions: [
        { id: "Bahasa Malaysia", name: "Bahasa Malaysia" },
        { id: "Bengali", name: "Bengali" },
        { id: "Burmese", name: "Burmese" },
        { id: "English", name: "English" },
        { id: "Indonesia", name: "Indonesia" },
        { id: "Nepali", name: "Nepali" },
        { id: "Tamil", name: "Tamil" },
        { id: "Thai", name: "Thai" },
        
      ],

    },
  ];

  useEffect(() => {
    setModalFields({
      ...modalFields,
      body: (
        <SendSms messageBody={messageBody} setMessageBody={setMessageBody} />
      ),
      onConfirm: () => {
        console.log(messageBody);
        setModalFields({ ...modalFields, isOpen: false });
      },
    });
  }, [messageBody]);

  const filterInitialValues = {
    langguage: "",
  };

  // const API_VERSION = "v1";
  // const API_URL = process.env.REACT_APP_API_URL;
  // let baseURL = `${API_URL}${API_VERSION}/`;

  // Action buttons props
  // const actionBarButtons = [
  //   {
  //     color: "primary",
  //     buttonLabel: "Add Contract",
  //   },
  // ];
  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }


  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}

      />

      <Table
        proxyURL={WORKER_CONTRACT_URL}
        model={model}
        actions={actions}
        pageNumberDropdown={pageNumberDropdown}

        linkUrlName='/view-details/'
        // excelExport={{ fileName: "WorkerReport" }}
        filterValues={filterValues}
        // actionBarButtons={actionBarButtons}
        noFilter
        isLanguageDelete={isLanguageDelete}

      />

      <Modal modalFields={modalFields} setModalFields={setModalFields} />
    </div>
  );
}
